import React from 'react';
import { CardSection } from '../../../../../common';
import { DisableReportingDuringTimeZone } from './DisableReportingDuringTimeZone/DisableReportingDuringTimeZone';
import { DisableReportingOf } from './DisableReportingOf/DisableReportingOf';
import { LocalPrinterSetup } from './LocalPrinterSetup/LocalPrinterSetup';
import styles from './reporting.module.scss';

const Reporting: React.FC = () => {
	return (
		<div className={styles.container}>
			<div className={styles.generalReporting}>
				<CardSection title={`${_('DisableReportingOf')}:`}>
					<DisableReportingOf />
				</CardSection>
				<CardSection title={_('DisableReportingDuringTimeZone')}>
					<DisableReportingDuringTimeZone />
				</CardSection>
				<CardSection title={_('LocalPrinterSetup')}>
					<LocalPrinterSetup />
				</CardSection>
			</div>
		</div>
	);
};

export { Reporting };
